import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Header from '../Header';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import { Control, LocalForm } from 'react-redux-form';
import { Helmet } from 'react-helmet';
import Footer from '../Footer';
import UserTable from './table';
import {Link} from "react-router-dom";
import ModalExample from "./pop";

const messages = defineMessages({
  htmlHeader: {
    id: 'preview.html.header',
    description:
      'The title of the page that appears in the html header of the page.',
    defaultMessage: 'Preview'
  },
  headerTitle: {
    id: 'user.management',
    description: 'Page Header Title',
    defaultMessage: 'User Management'
  },
  headerSubTitle: {
    id: 'empty.label.name',
    description: 'Page Header Subtitle',
    defaultMessage: ''
  },
  searchFiles: {
    id: 'preview.search.files',
    description: 'search files',
    defaultMessage: 'Search Files'
  },
  alertTitle: {
    id: 'preview.alert.title',
    description: 'Preview API alert title',
    defaultMessage: 'Loading Project Files Failed'
  }
});

class Management extends Component {
  componentDidMount(){
    //alert(this.props.customerid);
    this.setState({customerid:this.props.customerid})
    this.props.getusersList(this.props.username);
  }

  constructor(props) {
    super(props);
    const { intl } = this.props;
    this.state = {
      showInvite: false,
      showInviteSent: false,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      role: "",
      delUser: "",
      delEmail: "",
      status: "",
      customerid:""
    };
  }
  showInviteTrue = () => {
    this.setState({ showInvite: true });
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'User Invitation'
    };
  };
  showInviteFalse = () => {
    this.setState({ showInvite: false });
    messages.headerTitle = {
      id: 'user.management',
      description: 'Page Header Title',
      defaultMessage: 'User Management'
    };
  };

  sendInvite = () => {
   // alert( this.props.customerid);
    this.props.inviteUser(
      this.state.firstname,
      this.state.lastname,
      this.state.email,
      this.state.phone,
      this.props.username,
      this.state.role,
      this.state.customerid,
      this.invitedsent
    );
  }

  invitedsent = ()=>{
    this.setState({showInviteSent : true});
    messages.headerTitle = {
      id: 'user.invitation',
      description: 'Page Header Title',
      defaultMessage: 'Success'
    };
  }

  selectItem = (value)=>{
    console.log(value);
    this.setState({delUser: value.username,status: value.status,delEmail: value.email})
  }
  openModal = ()=>{};

  confirmationText = "Your Admin user has been changed successfully. Please log In with the credential for new admin user."


  render() {
    return (
      <div className="preview page">
        <Helmet>
          <title>
            {this.props.intl.formatMessage(messages.htmlHeader)} - SHIFT
          </title>
        </Helmet>
        <Header
          title={this.props.intl.formatMessage(messages.headerTitle)}
          subtitle={this.props.intl.formatMessage(messages.headerSubTitle)}
          icon="preview"
          locale={this.props.locale}
          status = {this.props.status}
        />
        <ModalExample
          hasTitle
          warning
          className="modal_sm"
          reset={()=>this.props.logout()}
          setClick={click => this.openModal = click}
          content={this.confirmationText}/>

        <div className="main">
          {this.state.showInvite &&(
            <div
              className="panel"
              style={{
                width: '90%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              {this.state.showInviteSent &&(
                <div>
                  <label
                    style={{
                      width: '90%',
                      fontSize: '16px',
                      textTransform: 'none',
                      lineHeight: '150%'
                    }}
                  >
                    An invitation with temporary password has been sent to the user.
                  </label>
                  <br />
                  &nbsp;
                  <br />
                  &nbsp;
                  <div className="button-container" style={{ textAlign: 'center' }}>
                    <button
                      className="button"
                      styel={{ padding: 20 }}
                      type="button"
                      onClick={() => window.location.reload()}
                    >
                      <FormattedMessage id="nav.ok" defaultMessage="OK" />
                    </button>
                  </div>
                </div>
              )}

              {!this.state.showInviteSent &&(
                <LocalForm
                  className="form"
                  model="user"
                  onSubmit={this.sendInvite}
                >
                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="user.firstname.title"
                        defaultMessage="First Name: "
                      />
                    </label>
                    <Control.text
                      model="user.firstname"
                      value={this.state.firstname}
                      autoFocus
                      onChange={event=>{this.setState({firstname: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="user.lastname.title"
                        defaultMessage="Last Name: "
                      />
                    </label>
                    <Control.text
                      model="user.lastname"
                      value={this.state.lastname}
                      autoFocus
                      onChange={event=>{this.setState({lastname: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="assessment.request.translation.Email.name"
                        defaultMessage="Email: "
                      />
                    </label>

                    <Control.text
                      model="user.email"
                      value={this.state.email}
                      type="email"
                      autoFocus
                      required
                      onChange={event=>{this.setState({email: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="telephone.label.name"
                        defaultMessage="Telephone"
                      />
                    </label>

                    <Control.text
                      model="user.phone"
                      value={this.state.phone}
                      autoFocus
                      onChange={event=>{this.setState({phone: event.target.value})}}
                    />
                  </fieldset>

                  <fieldset>
                    <label style={{ textTransform: 'capitalize' }}>
                      <FormattedMessage
                        id="projects.user.role"
                        defaultMessage="Role: "
                      />
                    </label>
                    {this.props.role.includes("CUSTOMER_ADMIN")&& (
                    <Control.select
                      model="user.role"
                      defaultValue={this.state.role}
                      autoFocus
                      required
                      onChange={event=>{this.setState({role: event.target.value})}}
                    >
                      <option value="">Please select one role</option>
                      <option value="PROFESSIONAL_SERVICE">User</option>
                      
                    </Control.select>
                    )}
                     {!this.props.role.includes("CUSTOMER_ADMIN")&& (
                    <Control.select
                      model="user.role"
                      defaultValue={this.state.role}
                      autoFocus
                      required
                      onChange={event=>{this.setState({role: event.target.value})}}
                    >
                      <option value="">Please select one role</option>
                      <option value="PROFESSIONAL_SERVICE">User</option>
                      
                    </Control.select>
                    )}
                  </fieldset>

                  <div className="button-container" style={{ textAlign: 'center' }}>

                    <button
                      className="button"
                      type="submit"
                      onClick={()=>{this.showInviteFalse();this.props.getusersList(this.props.username);} }
                      style={{ marginRight: '40px' }}
                    >
                      <FormattedMessage
                        id="run-assessment.back.button.name"
                        textTransform="capitalize"
                        defaultMessage="Back"
                      />
                    </button>


                    <button
                      className="button"
                      type="submit"
                    >
                      <FormattedMessage
                        id="submit.button.name"
                        defaultMessage="Submit"
                      />
                    </button>
                  </div>
                </LocalForm>
              )}

            </div>

          )}

          {!this.state.showInvite && (
            <div
              className="panel"
              style={{
                width: '90%',
                padding: '40px',
                boxSizing: 'content-box',
                marginTop: '15px',
                display: 'block',
                alignContent: 'center',
                marginLeft: 'auto',
                marginRight: 'auto'
              }}
            >
              <UserTable data={this.props.usersList} selectItem={this.selectItem}  username={this.props.username}/>

              <br/>
              <br/>
              <div
                className="button-container"
                style={{ textAlign: 'center' }}
              >
                <Link to="/en-CA/">
                  <button
                    className="button"
                    style={{ marginRight: '40px' }}
                    type="button"
                    // onClick={() => this.props.clickBackHandler()}
                  >
                    <FormattedMessage
                      id="run-assessment.back.button.name"
                      defaultMessage="Back"
                    />
                  </button>
                </Link>

                <button disabled={this.state.delUser==""}
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={()=>this.props.changeAdmin(this.props.username,this.state.delUser,this.openModal)}
                >
                  CHANGE ADMIN
                </button>

                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={this.showInviteTrue}
                >
                  <FormattedMessage
                    id="management.invite"
                    defaultMessage="INVITE USER"
                  />
                </button>

                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={()=>this.props.deleteUser(this.state.delUser,this.state.delEmail,this.props.username,this.props,this.selectItem)}
                  disabled={this.state.delUser === "" || this.state.status === "DELETED"}
                >
                  <FormattedMessage
                    id="projects.project.delete"
                    defaultMessage="Delete"
                  />
                </button>

                <button
                  className="button"
                  style={{ marginRight: '40px' }}
                  type="button"
                  onClick={()=>this.props.reactiveUser(this.state.delUser,this.state.delEmail,this.props.username,this.props,this.selectItem)}
                  disabled={this.state.delUser === "" || this.state.status !== "DELETED"}
                >
                  <FormattedMessage
                    id="management.reactive"
                    defaultMessage="reactive"
                  />
                </button>
              </div>
            </div>
          )}
        </div>
        <Footer />
      </div>
    );
  }
}

Management.propTypes = {
  username: PropTypes.string,
  usersList: PropTypes.array
};

export default injectIntl(Management);



// WEBPACK FOOTER //
// ./src/components/views/Management/index.js